import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";

const HeaderVendorHome = () => {
  const { Headers, isHeader } = useBlogContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check if Headers and its properties are available
  const isHeadersValid = Headers && Headers.meta_logo !== undefined && Headers.meta_title !== undefined;

  return (
    <>

      <header className="header py-2 mx-auto">
        <div className="header-content">
          <div className="left-content">
            <button
              id="mobile_menu_trigger_mob"
              className="icon dz-floating-toggler border-0 bg-transparent"
            >
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y={2} width={20} height={3} rx="1.5" fill="white" />
                <rect y={18} width={20} height={3} rx="1.5" fill="white" />
                <rect x={4} y={10} width={20} height={3} rx="1.5" fill="white" />
              </svg>
            </button>
          </div>
          <div className="mid-content text-center">
            <Link to="/" className="info w-auto mx-auto">
              {isHeadersValid ? (
                <h5
                  className="m-0 text-truncate text-primary text-center mx-auto fw-light text-uppercase"
                  style={{ maxWidth: 180 }}
                >
                  {Headers.meta_title}
                </h5>
              ) : (
                <div
                  className="card-1 skeleton mx-auto"
                  style={{ borderRadius: 5, aspectRatio: "35/8", height: 40 }}
                ></div>
              )}
            </Link>

          </div>
          <div className="right-content d-flex align-items-center gap-4">
            <NavLink to="/account/notification" className="font-25 badge-active">
              <i className="ri-notification-3-line"></i>
            </NavLink>
          </div>
        </div>
      </header>


    </>
  );
};

export default HeaderVendorHome;
